import React, { ReactNode } from 'react';
import { observer } from 'mobx-react';
import { AxiosResponse } from 'axios';
import { Navigate } from 'react-router-dom';
import { TafButton } from '@taf-ui/react';

import Requests from '../Requests/Requests';
import AppStorage from '../Storage/Storage';
import { translate } from '../utils/utils';
import RouteParams from '../interfaces/RouteParams';
import Labels from '../enums/Labels';

import './Rejected.css';
import { languageToReadSpeakerLang } from 'ReadSpeakerReader/ReadSpeakerProvider';
import ReadSpeakerReader from 'ReadSpeakerReader';

type RejectedProps = {
  initWholeAppFn?: () => void;
} & RouteParams;

type State = {
  navigateComponent: ReactNode;
};

class Rejected extends React.PureComponent<RejectedProps, State> {
  private readonly storage: AppStorage;

  constructor(props: RejectedProps) {
    super(props);
    this.storage = AppStorage.getInstance();
    this.state = {
      navigateComponent: null,
    };
  }

  handleReopenHandler = (response: AxiosResponse): void => {
    const { status } = response;

    if (status === 200) {
      this.redirectToInstructionsPage();
    }
  };

  redirectToInstructionsPage(): void {
    const { healthDeclarationId, initWholeAppFn } = this.props;

    if (initWholeAppFn) {
      initWholeAppFn();
    }

    this.storage.setFieldsWhenReopenHD();
    this.setState({
      navigateComponent: (
        <Navigate to={`/${healthDeclarationId}/instructions`} />
      ),
    });
  }

  reopen(): void {
    void Requests.reopenHealthDeclaration().then(this.handleReopenHandler);
  }

  render(): React.ReactElement {
    const lang = this.storage.getLocale;

    if (this.state.navigateComponent) {
      return <>{this.state.navigateComponent}</>;
    }

    return (
      <div
        className="rejected-screen"
        id="rejected-screen"
        lang={languageToReadSpeakerLang(lang)}
      >
        <ReadSpeakerReader id="rejected-screen" />
        <h1>{translate(Labels.REJECTED_HEADER, this.storage.getLocale)}</h1>
        <p className="info-message">
          {translate(Labels.REJECTED_P, this.storage.getLocale)}
        </p>
        <TafButton
          id="reopenBtn"
          onClick={this.reopen.bind(this)}
          type="button"
          primary={true}
          data-testid="reopenBtn"
          title={translate(
            Labels.EDIT_HEALTH_DECLARATION,
            this.storage.getLocale,
          )}
        >
          {translate(Labels.EDIT_HEALTH_DECLARATION, this.storage.getLocale)}
        </TafButton>
      </div>
    );
  }
}

export default observer(Rejected);
